/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_78fba61e"]'><div><cube-button @_click="showPicker">Time Picker</cube-button><cube-time-picker-modal title="时间选择器" content="请选择具体的时间" ref="__mpx_ref_picker__" :min="(min)" :max="(max)" :show-now="(showNow)" @change='(e)=>__invoke(e, [["onChange"]])' @toggle='(e)=>__invoke(e, [["onToggle"]])' @close='(e)=>__invoke(e, [["onClose"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])' @valueChange='(e)=>__invoke(e, [["onValueChange"]])'/><div :class='["demo-data"]' v-if="(confirmParams.length || valueChangeParams.length)"><div :class='["key"]'>其他事件可打开控制台查看输出</div><template v-if="(confirmParams.length)"><div :class='["key"]'>confirmParams 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (confirmParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template><template v-if="(valueChangeParams.length)"><div :class='["key"]'>valueChange 事件触发次数：{{ valueChangeCount }}</div><div :class='["key"]'>valueChangeParams 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (valueChangeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_78fba61e"}'>
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_78fba61e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_78fba61e"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker78fba61e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker78fba61e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_78fba61e"],
    ctorType: "component",
    outputPath: "components/basic-picker78fba61e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-time-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker-modal/index.mpx?isComponent&outputPath=components%2Findex42ee8cca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>